import React from 'react';
import { appName, appURL } from '../Constants';
import Footer from '../Footer';
import Navbar from '../Navbar';
import { useMenuItems } from '../menuItems';

const TermsAndConditions = () => {
    const { menuItems } = useMenuItems();
    return (
        <div className='font-sans antialiased bg-landing-white'>
            <Navbar menuItems={menuItems} />
            <section className='py-24 bg-gradient-to-br from-landing-slate-50 to-landing-white'>
                <div className='max-w-4xl mx-auto px-6'>
                    <div className='text-center mb-16'>
                        <span className='inline-flex items-center gap-2 bg-landing-blue-500/10 border border-landing-blue-500/20 rounded-full px-4 py-2 text-landing-blue-500 font-bold tracking-wide uppercase text-sm'>
                            Legal
                        </span>
                        <h1 className='text-4xl md:text-5xl font-bold text-landing-slate-900 mt-4 mb-6'>
                            Terms & Conditions
                        </h1>
                        <p className='text-xl text-landing-slate-600 max-w-2xl mx-auto leading-relaxed'>
                            Please read these terms and conditions carefully
                            before using {appName}
                        </p>
                        <p className='text-sm text-landing-slate-500 mt-2'>
                            Last Updated: February 2026
                        </p>
                    </div>

                    <div className='bg-landing-white rounded-2xl p-8 shadow-sm border border-landing-gray-100 space-y-6'>
                        <p className='text-lg leading-relaxed'>
                            These terms and conditions outline the rules and
                            regulations for the use of {appName}'s Website,
                            located at{' '}
                            <a
                                href={appURL}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='text-landing-blue-500 hover:text-landing-blue-600 underline font-medium'
                            >
                                {appURL}
                            </a>
                            .
                        </p>

                        <p>
                            By accessing this website or using our Services
                            (including our Microsoft Teams integration), you
                            accept these terms and conditions. Do not continue
                            to use{' '}
                            <a
                                href={appURL}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='text-landing-blue-500 underline'
                            >
                                {appURL}
                            </a>{' '}
                            if you do not agree to take all of the terms and
                            conditions stated on this page.
                        </p>

                        <div className='bg-landing-blue-50 border-l-4 border-landing-blue-500 p-4'>
                            <p className='text-landing-blue-900'>
                                <strong>Important:</strong> {appName} is an
                                Indian company registered and operating under
                                the laws of India. These terms are governed by
                                Indian law.
                            </p>
                        </div>

                        <p>
                            The following terminology applies to these Terms and
                            Conditions, Privacy Statement and Disclaimer Notice
                            and all Agreements: <strong>"Client"</strong>,{' '}
                            <strong>"You"</strong> and <strong>"Your"</strong>{' '}
                            refers to you, the person log on this website and
                            compliant to the Company's terms and conditions.{' '}
                            <strong>"The Company"</strong>,{' '}
                            <strong>"Ourselves"</strong>, <strong>"We"</strong>,{' '}
                            <strong>"Our"</strong> and <strong>"Us"</strong>,
                            refers to our Company. <strong>"Party"</strong>,{' '}
                            <strong>"Parties"</strong>, or <strong>"Us"</strong>
                            , refers to both the Client and ourselves. All terms
                            refer to the offer, acceptance and consideration of
                            payment necessary to undertake the process of our
                            assistance to the Client in the most appropriate
                            manner for the express purpose of meeting the
                            Client's needs in respect of provision of the
                            Company's stated services, in accordance with and
                            subject to, prevailing law of India. Any use of the
                            above terminology or other words in the singular,
                            plural, capitalization and/or he/she or they, are
                            taken as interchangeable and therefore as referring
                            to same.
                        </p>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Registration and Access
                            </h2>
                            <p className='mb-4'>
                                You must provide accurate and complete
                                information to register for an account to use
                                our Services. You may not share your account
                                credentials or make your account available to
                                anyone else and are responsible for all
                                activities that occur under your account. If you
                                create an account or use the Services on behalf
                                of another person or entity, you must have the
                                authority to accept these Terms on their behalf.
                            </p>
                            <p className='mb-4'>
                                <strong>Microsoft Account Integration:</strong>{' '}
                                If you choose to sign in using your Microsoft
                                account (via Microsoft OAuth or Microsoft
                                Teams), you authorize us to access your basic
                                profile information, organization information,
                                and email address from Microsoft. You can revoke
                                this access at any time through your Microsoft
                                account settings.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Microsoft Teams Integration
                            </h2>
                            <p className='mb-4'>
                                If you access our Services through Microsoft
                                Teams:
                            </p>
                            <ul className='list-disc pl-5 mb-4 space-y-2'>
                                <li>
                                    <strong>Authentication:</strong> You will
                                    authenticate using Microsoft's OAuth 2.0
                                    protocol. We do not have access to your
                                    Microsoft password.
                                </li>
                                <li>
                                    <strong>Organization Linking:</strong> We
                                    will automatically link your account to your
                                    organization based on your Microsoft tenant
                                    ID. This ensures you have access to your
                                    organization's knowledge base and settings.
                                </li>
                                <li>
                                    <strong>Bot Conversations:</strong> Your
                                    conversations with our Microsoft Teams bot
                                    are processed to provide responses and may
                                    be stored for service improvement and
                                    support purposes.
                                </li>
                                <li>
                                    <strong>Teams-Specific Features:</strong>{' '}
                                    Certain features may only be available when
                                    accessing our Services through Microsoft
                                    Teams, as determined by your organization
                                    administrator.
                                </li>
                                <li>
                                    <strong>Microsoft Terms:</strong> Your use
                                    of Microsoft Teams and Microsoft services is
                                    also subject to Microsoft's terms of
                                    service. We are not responsible for
                                    Microsoft's services or policies.
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Using our Services
                            </h2>
                            <h3 className='text-xl font-medium mb-2'>
                                What you can do:
                            </h3>

                            <p className='mb-4'>
                                Subject to your compliance with these Terms, you
                                may access and use our Services. In using our
                                Services, you must comply with all applicable
                                laws, Usage Policies, and any other
                                documentation, guidelines, or policies we make
                                available to you.
                            </p>

                            <h3 className='text-xl font-medium mb-2'>
                                What you cannot do:
                            </h3>
                            <ul className='list-disc list-inside mb-4 ml-3 space-y-2'>
                                <li>
                                    You may not use our Services for any
                                    illegal, harmful, or abusive activity. For
                                    example, you may not:
                                </li>
                                <li>
                                    Use our Services in a way that infringes,
                                    misappropriates or violates anyone's rights.
                                </li>
                                <li>
                                    Modify, copy, lease, sell or distribute any
                                    of our Services.
                                </li>
                                <li>
                                    Attempt to or assist anyone to reverse
                                    engineer, decompile or discover the source
                                    code or underlying components of our
                                    Services, including our models, algorithms,
                                    or systems (except to the extent this
                                    restriction is prohibited by applicable
                                    law).
                                </li>
                                <li>
                                    Automatically or programmatically extract
                                    data or Output (defined below).
                                </li>
                                <li>
                                    Represent that output from the Services was
                                    human-generated when it is not or otherwise
                                    violate our Usage Policies.
                                </li>
                                <li>
                                    Bypass, circumvent, or attempt to bypass or
                                    circumvent any Microsoft Teams
                                    authentication or access controls.
                                </li>
                                <li>
                                    Use the Services to impersonate any person
                                    or entity, or falsely state or misrepresent
                                    your affiliation with an organization.
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Organization Accounts
                            </h2>
                            <p className='mb-4'>
                                If you are using our Services as part of an
                                organization:
                            </p>
                            <ul className='list-disc pl-5 mb-4 space-y-2'>
                                <li>
                                    Your organization administrator may have
                                    access to your usage data, query history,
                                    and account information.
                                </li>
                                <li>
                                    Your organization may set policies, usage
                                    limits, and restrictions on your use of the
                                    Services.
                                </li>
                                <li>
                                    If you leave the organization or your access
                                    is revoked, you may lose access to
                                    organization-specific data and features.
                                </li>
                                <li>
                                    Your organization is responsible for
                                    ensuring proper licensing and compliance
                                    with these Terms for all users.
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Content
                            </h2>
                            <h3 className='text-xl font-medium mb-2'>
                                Your Content:
                            </h3>
                            <p className='mb-4'>
                                You may provide input to the Services ("Input"),
                                and receive output generated and returned by the
                                Services based on the Input ("Output"). Input
                                and Output are collectively "Content." You are
                                responsible for Content, including for ensuring
                                that it does not violate any applicable law or
                                these Terms.
                            </p>
                            <h3 className='text-xl font-medium mb-2'>
                                Ownership of Content:
                            </h3>
                            <p className='mb-4'>
                                As between you and {appName}, and to the extent
                                permitted by applicable law, you (a) retain your
                                ownership rights in Input and (b) own the
                                Output. We hereby assign to you all our right,
                                title, and interest, if any, in and to Output.
                            </p>
                            <h3 className='text-xl font-medium mb-2'>
                                Similarity of Content:
                            </h3>
                            <p className='mb-4'>
                                Due to the nature of our Services and artificial
                                intelligence generally, output may not be unique
                                and other users may receive similar output from
                                our Services. Our assignment above does not
                                extend to other users' output or any Third Party
                                Output.
                            </p>
                            <h3 className='text-xl font-medium mb-2'>
                                Use of Content to Provide and Maintain the
                                Services:
                            </h3>
                            <p className='mb-4'>
                                We may use Content to provide, maintain,
                                develop, and improve our Services, comply with
                                applicable law, enforce our terms and policies,
                                and keep our Services safe.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Fees and Payment
                            </h2>
                            <p className='mb-4'>
                                <strong>Fees:</strong> You will pay all fees
                                charged to your account according to the prices
                                and terms on the applicable pricing page, or as
                                otherwise agreed in writing. We have the right
                                to correct pricing errors or mistakes even after
                                invoicing. Payments are due within the period
                                specified in your invoice.
                            </p>
                            <p className='mb-4'>
                                <strong>Taxes:</strong> Unless otherwise stated,
                                fees do not include federal, state, local, or
                                foreign taxes, duties, or similar assessments
                                ("Taxes"). You are responsible for all
                                applicable Taxes except those based on {appName}
                                's net income, and we will invoice you for such
                                Taxes if we are obligated to do so by law. All
                                payments must be made in Indian Rupees (INR)
                                unless otherwise agreed.
                            </p>
                            <p className='mb-4'>
                                <strong>Price Changes:</strong> We may change
                                our prices by giving you at least 30 days'
                                advance notice via email or through the
                                Services. Price changes will apply to the next
                                billing cycle.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Confidentiality, Security, and Data Protection
                            </h2>
                            <p className='mb-4'>
                                <strong>Confidentiality:</strong> You may be
                                given access to Confidential Information of{' '}
                                {appName}, its affiliates, and other third
                                parties. You may use Confidential Information
                                only as needed to use the Services. You may not
                                disclose Confidential Information to any third
                                party, and you will protect Confidential
                                Information in the same manner that you protect
                                your own confidential information of a similar
                                nature, with at least a reasonable standard of
                                care.
                            </p>
                            <p className='mb-4'>
                                <strong>Security:</strong> You must implement
                                reasonable and appropriate measures designed to
                                help secure your access to and use of the
                                Services. If you discover any vulnerabilities or
                                breaches related to your use of the Services,
                                you must promptly contact {appName} and provide
                                details of the vulnerability or breach.
                            </p>
                            <p className='mb-4'>
                                <strong>Processing of Personal Data:</strong> If
                                you use the Services to process personal data,
                                you must provide legally adequate privacy
                                notices and obtain necessary consents for the
                                processing of such data, and you represent to us
                                that you are processing such data in accordance
                                with applicable law, including the Information
                                Technology Act, 2000 and applicable rules.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Term and Termination
                            </h2>
                            <p className='mb-4'>
                                <strong>Termination; Suspension:</strong> These
                                Terms take effect when you first use the
                                Services and remain in effect until terminated.
                                You may terminate these Terms at any time for
                                any reason by discontinuing the use of the
                                Services. We may terminate these Terms for any
                                reason by providing you at least 30 days'
                                advance notice. We may terminate these Terms
                                immediately upon notice to you if you materially
                                breach these Terms or if we are required to do
                                so by law.
                            </p>
                            <p className='mb-4'>
                                We may suspend your access to the Services if
                                you materially breach these Terms or if your use
                                of the Services creates security risks or
                                threatens the integrity of the Services.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Indemnification; Disclaimer of Warranties;
                                Limitations on Liability
                            </h2>
                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Indemnity:
                            </h3>
                            <p className='mb-4'>
                                You will defend, indemnify, and hold harmless
                                us, our affiliates, and our personnel, from and
                                against any claims, losses, and expenses
                                (including attorneys' fees) arising from or
                                relating to your use of the Services, including
                                your Content, products or services you develop
                                or offer in connection with the Services, and
                                your breach of these Terms or violation of
                                applicable law.
                            </p>

                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Disclaimer:
                            </h3>
                            <p className='mb-4 uppercase font-semibold'>
                                THE SERVICES ARE PROVIDED "AS IS" AND "AS
                                AVAILABLE". WE DISCLAIM ALL WARRANTIES, WHETHER
                                EXPRESS, IMPLIED, OR STATUTORY, INCLUDING
                                WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                                PARTICULAR PURPOSE, SATISFACTORY QUALITY,
                                NON-INFRINGEMENT, AND QUIET ENJOYMENT. WE DO NOT
                                WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED,
                                ACCURATE, OR ERROR-FREE, OR THAT ANY CONTENT
                                WILL BE SECURE OR NOT LOST OR ALTERED.
                            </p>

                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Limitations of Liability:
                            </h3>
                            <p className='mb-4 uppercase font-semibold'>
                                NEITHER WE NOR ANY OF OUR AFFILIATES OR
                                LICENSORS WILL BE LIABLE FOR ANY INDIRECT,
                                INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY
                                DAMAGES, INCLUDING DAMAGES FOR LOSS OF PROFITS,
                                GOODWILL, USE, DATA, OR OTHER LOSSES, EVEN IF WE
                                HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH
                                DAMAGES. OUR AGGREGATE LIABILITY UNDER THESE
                                TERMS SHALL NOT EXCEED THE GREATER OF THE AMOUNT
                                YOU PAID FOR THE SERVICE THAT GAVE RISE TO THE
                                CLAIM DURING THE 12 MONTHS BEFORE THE LIABILITY
                                AROSE OR ONE HUNDRED RUPEES (₹100). THE
                                LIMITATIONS IN THIS SECTION APPLY ONLY TO THE
                                MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Dispute Resolution
                            </h2>
                            <p className='mb-4'>
                                <strong>Governing Law:</strong> These Terms are
                                governed by the laws of India, without regard to
                                conflict of law principles.
                            </p>
                            <p className='mb-4'>
                                <strong>Jurisdiction:</strong> Any disputes
                                arising out of or relating to these Terms or the
                                Services will be resolved exclusively in the
                                courts of competent jurisdiction in New Delhi,
                                India, and you consent to the jurisdiction of
                                those courts.
                            </p>
                            <p className='mb-4'>
                                <strong>Arbitration Option:</strong> Before
                                filing a lawsuit, you agree to try to resolve
                                the dispute informally by contacting us. If a
                                dispute is not resolved within 60 days of
                                submission, either party may elect to submit the
                                dispute to binding arbitration under the
                                Arbitration and Conciliation Act, 1996, to be
                                conducted in New Delhi, India, in English.
                            </p>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                Copyright Complaints
                            </h2>

                            <p className='mb-4'>
                                If you believe that your intellectual property
                                rights have been infringed, please send notice
                                to the email address below. We may delete or
                                disable content that we believe violates these
                                Terms or is alleged to be infringing and will
                                terminate accounts of repeat infringers where
                                appropriate.
                            </p>

                            <p className='mb-4'>
                                Written claims concerning copyright infringement
                                must include the following information:
                            </p>
                            <ul className='list-disc pl-5 mb-4 space-y-2'>
                                <li>
                                    A physical or electronic signature of the
                                    person authorized to act on behalf of the
                                    owner of the copyright interest
                                </li>
                                <li>
                                    A description of the copyrighted work that
                                    you claim has been infringed upon
                                </li>
                                <li>
                                    A description of where the allegedly
                                    infringing material is located on our site
                                    so we can find it Your address, telephone
                                    number, and e-mail address
                                </li>
                                <li>
                                    A statement by you that you have a
                                    good-faith belief that the disputed use is
                                    not authorized by the copyright owner, its
                                    agent, or the law
                                </li>
                                <li>
                                    A statement by you that the above
                                    information in your notice is accurate and,
                                    under penalty of perjury, that you are the
                                    copyright owner or authorized to act on the
                                    copyright owner's behalf
                                </li>
                            </ul>
                        </div>

                        <div>
                            <h2 className='text-2xl font-semibold mb-4'>
                                General Terms
                            </h2>

                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Assignment
                            </h3>
                            <p className='mb-4'>
                                You may not assign or transfer any rights or
                                obligations under these Terms and any attempt to
                                do so will be void. We may assign our rights or
                                obligations under these Terms to any affiliate,
                                subsidiary, or successor in interest of any
                                business associated with our Services.
                            </p>

                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Changes to these Terms or our Services
                            </h3>
                            <p className='mb-4'>
                                We are continuously working to develop and
                                improve our Services. We may update these Terms
                                or our Services accordingly from time to time.
                                For example, we may make changes to these Terms
                                or the Services due to:
                            </p>
                            <ul className='list-disc pl-5 mb-4 space-y-1'>
                                <li>
                                    Changes to the law or regulatory
                                    requirements.
                                </li>
                                <li>Security or safety reasons.</li>
                                <li>
                                    Circumstances beyond our reasonable control.
                                </li>
                                <li>
                                    Changes we make in the usual course of
                                    developing our Services.
                                </li>
                                <li>To adapt to new technologies.</li>
                            </ul>
                            <p className='mb-4'>
                                We will give you at least 30 days advance notice
                                of changes to these Terms that materially
                                adversely impact you either via email or an
                                in-product notification. All other changes will
                                be effective as soon as we post them to our
                                website. If you do not agree to the changes, you
                                must stop using our Services.
                            </p>

                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Delay in Enforcing These Terms
                            </h3>
                            <p className='mb-4'>
                                Our failure to enforce a provision is not a
                                waiver of our right to do so later. Except as
                                provided in the dispute resolution section
                                above, if any portion of these Terms is
                                determined to be invalid or unenforceable, that
                                portion will be enforced to the maximum extent
                                permissible and it will not affect the
                                enforceability of any other terms.
                            </p>

                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Entire Agreement
                            </h3>
                            <p className='mb-4'>
                                These Terms contain the entire agreement between
                                you and {appName} regarding the Services and,
                                other than any Service-specific terms,
                                supersedes any prior or contemporaneous
                                agreements between you and {appName}.
                            </p>

                            <h3 className='text-xl font-medium mt-4 mb-2'>
                                Governing Law
                            </h3>
                            <p className='mb-4'>
                                Indian law will govern these Terms except for
                                its conflicts of laws principles. Except as
                                provided in the dispute resolution section
                                above, all claims arising out of or relating to
                                these Terms will be brought exclusively in the
                                courts of competent jurisdiction in New Delhi,
                                India.
                            </p>
                        </div>

                        <div className='bg-landing-slate-50 p-6 rounded-lg mt-6'>
                            <h3 className='text-lg font-semibold mb-3'>
                                Company Information
                            </h3>
                            <p className='mb-2'>
                                <strong>{appName}</strong> is a company
                                registered and operating in India.
                            </p>
                            <p className='mb-2'>
                                <strong>Registered Office:</strong> India
                            </p>
                            <p className='mb-2'>
                                <strong>Governing Law:</strong> These Terms are
                                governed by the laws of India.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default TermsAndConditions;
